import React, { useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const PubliationAdd = () => {
    const { http } = ProtectAPi();
    const navigate = useNavigate();
    const editor = useRef(null);
    const [loader, setLoader] = useState('off');
    const [layoutTitle, setLayoutTitle] = useState('');
    const [layoutSlug, setLayoutSlug] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [layoutAltText, setLayoutAltText] = useState('');
    
    const [layoutImageError, setLayoutImageError] = useState('');
    const [layoutAltTextError, setLayoutAltTextError] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [titleError, setTitleError] = useState('');
    const [slugError, setSlugError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('title', layoutTitle);
        formData.append('slug', layoutSlug);
        formData.append('description', layoutDescription);
        formData.append('image', layoutImage);
        formData.append('alt', layoutAltText); // ✅ alt text যুক্ত করা হয়েছে

        http.post(`/store-publication`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setTitleError(errors.slug ? errors.slug[0] : '');
                setSlugError(errors.title ? errors.title[0] : '');
                setDescriptionError(errors.description ? errors.description[0] : '');
                setLayoutAltTextError(errors.alt ? errors.alt[0] : ''); // ✅ alt error handle
            } else {
                setLoader('off');
                navigate('/admin/pages/home/publication-list');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') {
            setLayoutTitle(value);
        } else if (name === 'layoutSlug') {
            setLayoutSlug(value);
        } else if (name === 'layoutAltText') {
            setLayoutAltText(value);
        }
    };

    const placeholder = 'Start typing...'; 
    const editorConfig = useMemo(
        () => ({
            readonly: false,
            placeholder: placeholder || 'Start typing...',
            uploader: {
                insertImageAsBase64URI: true 
            }
        }),
        [placeholder]
    );

    return (
        <div>
            <div className="main-content">
                <section className="section">
                    <div className="section-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="card card-primary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <h5>Add Publication</h5>
                                            <div className="">
                                                <BackButton />
                                            </div>
                                        </div>
                                        <div className="card-body pb-0">
                                            <div className="row">
                                               <div className="col-md-4 mt-4">
                                                    <label>Publication Image</label>
                                                    <div className="logo-box">
                                                        <div className="logo">
                                                            <label htmlFor="layoutImage" className="w-100">
                                                                <div className="image-box border p-2 rounded shadow-sm d-flex justify-content-center align-items-center" style={{ height: '220px', overflow: 'hidden', backgroundColor: '#f9f9f9' }}>
                                                                    {imagePreview ? (
                                                                        <img
                                                                            src={imagePreview}
                                                                            alt="Preview"
                                                                            className="img-fluid rounded"
                                                                            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"
                                                                            alt="Default"
                                                                            className="img-fluid rounded"
                                                                            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                                <span className="btn btn-primary mt-2 w-100">Upload Publication Image</span>
                                                                <span className="text-danger">{layoutImageError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-md-12 mt-2">
                                                    <div className="form-group mt-3">
                                                        <label>Alt Text for Image (SEO & Accessibility)</label>
                                                        <input
                                                            type="text"
                                                            name="layoutAltText"
                                                            value={layoutAltText}
                                                            className="form-control"
                                                            placeholder="Enter alt text for the image"
                                                            onChange={handleInputChange}
                                                        />
                                                        <span className="text-danger">{layoutAltTextError}</span>
                                                    </div>
                                                </div>


                                                <div className="col-md-12 mt-2">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" name="layoutTitle" value={layoutTitle} className="form-control ms-0" placeholder='Enter Title' onChange={handleInputChange} />
                                                        <span className='text-danger'>{titleError}</span>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-2">
                                                    <div className="form-group">
                                                        <label>Slug (Optional)</label>
                                                        <input type="text" name="layoutSlug" value={layoutSlug} className="form-control ms-0" placeholder='Enter Slug' onChange={handleInputChange} />
                                                        <span className='text-danger'>{slugError}</span>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-4">
                                                    <label>Description</label>
                                                    <div style={{ border: '1px solid #ced4da', borderRadius: '0.25rem', overflow: 'hidden' }}>
                                                        <JoditEditor
                                                            ref={editor}
                                                            value={layoutDescription}
                                                            config={{
                                                                readonly: false,
                                                                height: 300,
                                                                placeholder: 'Start typing...',
                                                                uploader: {
                                                                    insertImageAsBase64URI: true
                                                                }
                                                            }}
                                                            tabIndex={1}
                                                            onBlur={newContent => setLayoutDescription(newContent)}
                                                            onChange={newContent => {}}
                                                        />
                                                    </div>
                                                    <span className='text-danger'>{descriptionError}</span>
                                                </div>


                                                <div className="col-md-12 mt-5 mb-3">
                                                    <label className="col-form-label"></label>
                                                    {loader === 'off' ?
                                                        <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Create</button> :
                                                        <div className="spinner-border text-dark" role="status"></div>
                                                    }
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PubliationAdd;
